import { Spinner } from '@wordpress/components';

/**
 * A loading component that displays a spinner.
 *
 * @param {Object}  props             Component props
 * @param {number}  props.aspectRatio Aspect ratio of the loader
 * @param {boolean} props.isCircular  Whether the loader should be circular
 *
 * @return {JSX.Element}
 */
const Loading = ({ aspectRatio = 16 / 9, isCircular = false }) => (
  <div
    className="mediapress-image-variation-picker-loader"
    style={{
      aspectRatio: `${aspectRatio}`,
      borderRadius: isCircular ? '50%' : '0',
    }}
  >
    <Spinner />
  </div>
);

export default Loading;
